// extracted by mini-css-extract-plugin
export default {"Role":"styles_Role__jS7JM"};